import {FC, useMemo, useState} from "react";
import styled from "styled-components";
import {RectangularButtonHollow} from "../../../components/buttons";
import {LayoutConst} from "../../../../core";
import {createVoting} from "../../../helpers/createVoting";
import {useHistory} from "react-router-dom";
import {Colors} from '@brg/ui';
import {IPollInfo} from "../../../constants/IPollInfo";
import {GameStatuses} from "../../../constants/GameStatuses";
import {useTranslation} from "react-i18next";

export const CreateVotingButton = styled(RectangularButtonHollow)<{replayOnly?: boolean}>`
  height: 46px!important;
  padding: 0px 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${Colors.geoWhite100};
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack47};
  cursor: pointer;
  text-align: center;
  width: fit-content!important;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 44px!important;
    font-size: 15px;
    margin-top: 16px;
  }
    
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 24px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%!important;
    margin-top: 24px;
  }

  &:disabled {
    background: transparent;
    border: 1px solid ${Colors.galBlack47};
  }
`;


export const ProjectStartGameButton: FC<{disabled?: boolean, pollInfo?: IPollInfo, projectId?: string, replayOnly?: boolean}> =
    ({disabled, pollInfo, projectId = '', replayOnly}) => {

    const history = useHistory();
    const isGameClosed = useMemo(() => pollInfo?.status === GameStatuses.closed, [pollInfo]);
    const [isLoading, setIsLoading] = useState(false)
    const { t } = useTranslation();


    if (!pollInfo) return null;

    return <CreateVotingButton replayOnly={replayOnly} disabled={disabled || isLoading}
                               onClick={() => createVoting(replayOnly ? true : isGameClosed, projectId, pollInfo?.id || '', history, setIsLoading)}>
        {t(`voting.buttons.${(disabled || isLoading) ? 'waiting' : (isGameClosed || replayOnly) ? 'replay' : 'create_game'}`)}
    </CreateVotingButton>
}import {FC, useMemo, useState} from "react";
import styled from "styled-components";
import {RectangularButtonHollow} from "../../../components/buttons";
import {LayoutConst} from "../../../../core";
import {createVoting} from "../../../helpers/createVoting";
import {useHistory} from "react-router-dom";
import {Colors} from '@brg/ui';
import {IPollInfo} from "../../../constants/IPollInfo";
import {GameStatuses} from "../../../constants/GameStatuses";
import {useTranslation} from "react-i18next";

export const CreateVotingButton = styled(RectangularButtonHollow)<{replayOnly?: boolean}>`
  height: 46px!important;
  padding: 0px 48px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${Colors.geoWhite100};
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.34px;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack47};
  cursor: pointer;
  text-align: center;
  width: fit-content!important;
  
  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 44px!important;
    font-size: 15px;
    margin-top: 16px;
  }
    
  @media (max-width: ${LayoutConst.screen.m}px) {
    margin-top: 24px;
  }
  @media (max-width: ${LayoutConst.screen.s}px) {
    width: 100%!important;
    margin-top: 24px;
  }

  &:disabled {
    background: transparent;
    border: 1px solid ${Colors.galBlack47};
  }
`;


export const ProjectStartGameButton: FC<{disabled?: boolean, pollInfo?: IPollInfo, projectId?: string, replayOnly?: boolean}> =
    ({disabled, pollInfo, projectId = '', replayOnly}) => {

    const history = useHistory();
    const isGameClosed = useMemo(() => pollInfo?.status === GameStatuses.closed, [pollInfo]);
    const [isLoading, setIsLoading] = useState(false)
    const { t } = useTranslation();


    if (!pollInfo) return null;

    return <CreateVotingButton replayOnly={replayOnly} disabled={disabled || isLoading}
                               onClick={() => createVoting(replayOnly ? true : isGameClosed, projectId, pollInfo?.id || '', history, setIsLoading)}>
        {t(`voting.buttons.${(disabled || isLoading) ? 'waiting' : (isGameClosed || replayOnly) ? 'replay' : 'create_game'}`)}
    </CreateVotingButton>
}